import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=33e649ee&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.vue?vue&type=style&index=0&id=33e649ee&prod&lang=scss&scoped=true&"
import style1 from "./Landing.vue?vue&type=style&index=1&id=33e649ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e649ee",
  null
  
)

export default component.exports